import {values} from '../utils'

/** 휴대폰 앞자리 번호 */
export const MobilePrefix = {
    '010': '010',
} as const

/** 휴대폰 앞자리 번호 목록 */
export const MobilePrefixes = values(MobilePrefix)

export const CashReceiptMobilePriefix = {
    '010': '010',
    '011': '011',
    '016': '016',
    '017': '017',
    '018': '018',
    '019': '019',
} as const

/** 휴대폰 앞자리 번호 목록 */
export const CashReceiptMobilePriefixs = values(CashReceiptMobilePriefix)

/** Select 등에 공용으로 사용할 휴대폰 앞자리 Option 목록 */
export const MobilePrefixOptions = MobilePrefixes.map((prefix) => ({title: prefix, value: prefix}))

/** 전화번호 중 지역번호 */
export const AreaCode = {
    '02': '02',
    '031': '031',
    '032': '032',
    '033': '033',
    '041': '041',
    '042': '042',
    '043': '043',
    '044': '044',
    '051': '051',
    '052': '052',
    '053': '053',
    '054': '054',
    '055': '055',
    '061': '061',
    '062': '062',
    '063': '063',
    '064': '064',
} as const

/** 전화번호 중 지역번호 목록 */
export const AreaCodes = values(AreaCode)

/** 기타 서비스용 앞자리 번호 */
export const OtherCode = {
    '070': '070',
    '080': '080',
    '0130': '0130',
    '0303': '0303',
    '0502': '0502',
    '0503': '0503',
    '0504': '0504',
    '0505': '0505',
    '0506': '0506',
    '0507': '0507',
    '0508': '0508',
    '050': '050',
} as const

/** 일반국번 */
export const GeneralCountryCodeList = [
    '010',
    '02',
    '031',
    '032',
    '033',
    '041',
    '042',
    '043',
    '044',
    '051',
    '052',
    '053',
    '054',
    '055',
    '061',
    '062',
    '063',
    '064',
    '070',
]

/** 기타 서비스용 앞자리 번호 목록 */
export const OtherCodes = values(OtherCode)

/** 유선전화 앞자리 번호 목록 */
export const TelephonePrefixes = [...AreaCodes, ...OtherCodes]

/** 전화번호 앞자리 전체 목록 */
export const AllPhonePrefixes = [...MobilePrefixes, ...TelephonePrefixes]

/** 4자리 - 4자리를 만족하는 통신망 목록 */
export const PhonePrefixMobileType: string[] = [...MobilePrefixes, '070']

/** 3|4자리 - 4자리를 만족하는 통신망 목록 */
export const PhonePrefixAreaType: string[] = [...AreaCodes, ...OtherCodes.splice(2)]

/** 3자리 - 4자리를 만족하는 통신망 목록 */
export const PhonePrefixEtcType: string[] = ['080']

/** 안심번호 사용 불가 번호 리스트 */
export const VirtualPhoneNumberUnavailableCodeList = [
    '080',
    '0130',
    '0303',
    '0502',
    '0503',
    '0504',
    '0505',
    '0506',
    '0507',
    '0508',
    '050',
    '012',
    '059',
]
